<gtw-confirmation-modal
  [config]="modalConfig"
  [visible]="true"
  (confirmed)="onConfirmDelete()"
  (cancelled)="cancel()"
  (closed)="cancel()">
</gtw-confirmation-modal>
